export default {
  group: {
    label: 'Group selection',
    keys: ['super+g'],
    default: true,
    desc: 'Groups the current selection into a frame'
  },
  ungroup: {
    label: 'Ungroup selection',
    disabled: true,
    keys: ['super+shift+g'],
    default: true,
    desc: 'Ungroups all frames in the current selection'
  },
  arrange: {
    label: 'Move layer',
    keys: ['super+up', 'super+down'],
    default: true,
    desc: 'Arrange layer, up to move forward, down to move back'
  },
  absoluteArrange: {
    label: 'Move layer to front or back',
    keys: ['super+alt+up', 'super+alt+down'],
    default: true,
    desc: 'Move layer to front or back'
  },
  selectAll: {
    label: 'Select all',
    keys: ['super+a'],
    default: false,
    desc: 'Selects everyting on the current page'
  },
  deselect: {
    label: 'Deselect',
    keys: ['esc'],
    default: false,
    desc: 'Deselect the current selection'
  }, 
  layerToggleVisibility: {
    label: 'Toggle visibility',
    keys: ['alt+q'],
    default: false,
    desc: 'Toggle layer visibility, selection'
  },
  layerLockLayer: {
    label: 'Lock/unlock layer',
    keys: ['alt+w'],
    default: false,
    desc: 'Toggle layer lock, selection'
  }
};
